import styled from 'styled-components';
import { orange, white } from '../../../../style/colors';

export const DropdownContainer = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  right: 0;
  background: ${white};
  border: 1.5px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08);
  max-height: 450px;
  overflow: hidden;
  z-index: 1000;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  visibility: ${(props) => (props.isVisible ? 'visible' : 'hidden')};
  transform: ${(props) => (props.isVisible ? 'translateY(0)' : 'translateY(-10px)')};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const DropdownHeader = styled.div`
  padding: 14px 18px;
  font-size: 11px;
  font-weight: 700;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: linear-gradient(to bottom, #fafafa, #f5f5f5);
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  gap: 8px;

  i {
    font-size: 14px;
    color: ${orange};
  }
`;

export const SuggestionsList = styled.div`
  max-height: 380px;
  overflow-y: auto;
`;

export const SuggestionItem = styled.button`
  width: 100%;
  background: none;
  border: none;
  padding: 16px 18px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid #f3f4f6;

  &:hover {
    background: linear-gradient(to right, #fff5f0, #fffbf5);
    border-left: 3px solid ${orange};
    padding-left: 15px;
  }

  &:last-child {
    border-bottom: none;
  }

  &:active {
    transform: scale(0.99);
  }
`;

export const TyreTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 700;
  color: #111827;
  line-height: 1.4;
`;

export const TyreDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #6b7280;
  flex-wrap: wrap;

  > span {
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;

export const TyreBrand = styled.span`
  color: ${orange};
  font-weight: 600;
  background: #fff5f0;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
`;

export const DetailBadge = styled.span`
  background: #f3f4f6;
  color: #374151;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
`;

export const PriceBadge = styled.span`
  color: #059669;
  font-weight: 700;
  font-size: 14px;
`;

export const Highlight = styled.mark`
  background: linear-gradient(120deg, #fff5f0 0%, #ffe0cc 100%);
  color: ${orange};
  font-weight: 700;
  padding: 2px 4px;
  border-radius: 4px;
`;

export const LoadingContainer = styled.div`
  padding: 32px 16px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const LoadingSpinner = styled.i`
  font-size: 32px;
  color: ${orange};
  animation: spin 0.8s linear infinite;
  
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const EmptyState = styled.div`
  padding: 32px 16px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;

  i {
    font-size: 48px;
    color: #d1d5db;
  }
`;


